var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { customElement, property, query } from 'lit/decorators.js';
import { BaseComponent } from '../utils/BaseComponent';
let TextArea = class TextArea extends BaseComponent {
    constructor() {
        super(...arguments);
        this.value = '';
        this.placeHolder = '';
        this.maxLength = 500;
        this.createCustomEventInput = (e) => {
            this.dispatchEvent(new CustomEvent('input', {
                detail: e.target.value,
                bubbles: true,
                composed: true
            }));
            e.stopPropagation();
            e.preventDefault();
        };
    }
    firstUpdated() {
        if (this.autoFocus) {
            this.textArea.focus();
        }
    }
    render() {
        var _a;
        const border = ((_a = this.value) === null || _a === void 0 ? void 0 : _a.length) < this.maxLength ? ' border-bluegray hover:border-gray-500 focus:border-primary focus:caret-primary focus:border-2' :
            'border-red-400';
        return html `
          <textarea
            data-test=${this.dataTest || 'text-area'}
            class=${`w-full mt-8 py-12 px-8 block min-h-[4rem] border-[1px] rounded bg-white ${border} focus:outline-none ${this.classNames}`}
            placeholder=${this.placeHolder}
            .value=${this.value}
            @input=${this.createCustomEventInput}
            maxlength=${this.maxLength}
          ></textarea>
          <slot></slot>
        `;
    }
};
__decorate([
    property()
], TextArea.prototype, "value", void 0);
__decorate([
    property()
], TextArea.prototype, "placeHolder", void 0);
__decorate([
    property({ type: Number })
], TextArea.prototype, "maxLength", void 0);
__decorate([
    property({ type: Boolean })
], TextArea.prototype, "autoFocus", void 0);
__decorate([
    property()
], TextArea.prototype, "classNames", void 0);
__decorate([
    query('textarea')
], TextArea.prototype, "textArea", void 0);
TextArea = __decorate([
    customElement('trust-text-area')
], TextArea);
export { TextArea };
//# sourceMappingURL=textArea.js.map